export type OwnerTransferStatusDescriptor = {
  name: string;
  value: number;
  description: string;
}

export type OwnerTransferEventDescriptor = {
  name: string;
  value: number;
  description: string;
}

export class OwnerTransferConstants {
  /**********************************************************
   * If changes are made, API code must be updated to match *
   **********************************************************/

  static readonly OT_UNKNOWN: number = 0; // Must match lookup value
  static readonly OT_PENDING: number = 1; // Must match lookup value
  static readonly OT_COMPLETE: number = 2; // Must match lookup value
  static readonly OT_DECLINED: number = 3; // Must match lookup value
  static readonly OT_CANCELLED: number = 4; // Must match lookup value

  static readonly OT_TERMINAL_STATES = [
    OwnerTransferConstants.OT_COMPLETE,
    OwnerTransferConstants.OT_DECLINED,
    OwnerTransferConstants.OT_CANCELLED,
  ];

  static status: OwnerTransferStatusDescriptor[] = [
    { name: 'Unknown', value: 0, description: 'None or Unknown' },
    {
      name: 'Initiated',
      value: 1,
      description: 'Initiated by Health Record Owner',
    },
    {
      name: 'Completed',
      value: 2,
      description: 'Transfer to new owner has been completed',
    },
    {
      name: 'Declined',
      value: 3,
      description: 'New owner declined to become Owner',
    },
    { name: 'Cancelled', value: 4, description: 'Transfer was cancelled' },
  ];

  static eventTypes: OwnerTransferEventDescriptor[] = [
    {
      name: 'Unknown',
      value: 0,
      description: 'Unknown event type'
    },
    {
      name: 'Initiated',
      value: 1,
      description: 'Owner transfer initiated',
    },
    {
      name: 'TargetRegistration',
      value: 2,
      description: 'Target owner registered for SurvivorLink account',
    },
    {
      name: 'TargetViewedInvitation',
      value: 3,
      description: 'New owner viewed transfer invitation',
    },
    {
      name: 'TargetAccepted',
      value: 4,
      description: 'New owner accepted the health record transfer',
    },
    {
      name: 'TargetDeclined',
      value: 5,
      description: 'Target owner declined the transfer',
    },
    {
      name: 'Cancelled',
      value: 6,
      description: 'Current owner cancelled the transfer',
    },
    {
      name: 'NewMrrUpdated',
      value: 7,
      description: 'Medical Record Release for former owner updated',
    },
    {
      name: 'OldMrrUpdated',
      value: 8,
      description: 'Existing Medical Record Release updated',
    },
    {
      name: 'AclUpdated',
      value: 9,
      description: 'Permissions updated'
    },
    {
      name: 'SharingUpdated',
      value: 10,
      description: 'Sharing updated'
    },
    {
      name: 'TransferCompleted',
      value: 11,
      description: 'Owner transfer completed'
    },
    {
      name: 'Other',
      description: 'Other',
      value: 12
    },
  ];
}

